import {
  handleTimeSeriesTableFilters,
  validateAndGenerateParams,
} from "helpers/marketAnalysisHelper";
import api from "./api";

const MARKET_ANALYSIS_END_POINT = "market-analysis";
const TIME_SERIES_END_POINT = `${MARKET_ANALYSIS_END_POINT}/time-series`;
const MARKET_ANALYSIS_GRAPH_END_POINT = `${MARKET_ANALYSIS_END_POINT}/graphs`;
const EXPORT_MARKET_ANALYSIS_END_POINT = `${MARKET_ANALYSIS_END_POINT}/export`;
const EXPORT_FILES_END_POINT = `${MARKET_ANALYSIS_END_POINT}/export-files`;
const FILTERS_GRAPH_END_POINT = `${MARKET_ANALYSIS_GRAPH_END_POINT}/filters`;
const TABLE_FILTER_END_POINT = `${MARKET_ANALYSIS_END_POINT}/get-table-filters`;
const TIME_SERIES_DELTA_END_POINT = `${MARKET_ANALYSIS_END_POINT}/time-series/deltas`;
const TIME_SERIES_TENORS_END_POINT = `${MARKET_ANALYSIS_END_POINT}/time-series/tenors`;
const TIME_SERIES_PERIOD_TYPES_END_POINT = `${MARKET_ANALYSIS_END_POINT}/time-series/period-types`;
const TIME_SERIES_GRAPH_END_POINT = `${MARKET_ANALYSIS_END_POINT}/time-series/graphs`;
const DAILY_REPORT_END_POINT = `${MARKET_ANALYSIS_END_POINT}/daily-report`;
const IRON_MATRIX_END_POINT = `${MARKET_ANALYSIS_END_POINT}/matrix/iron`;
const IRON_MATRIX_TENORS_END_POINT = `${MARKET_ANALYSIS_END_POINT}/matrix/tenors`;
const IRON_MATRIX_OPTION_TYPES_END_POINT = `${MARKET_ANALYSIS_END_POINT}/matrix/option-types`;
const IRON_MATRIX_PULL_TO_PRICER_END_POINT = `${MARKET_ANALYSIS_END_POINT}/matrix/pull-to-pricer`;
const CUSTOMER_DETAILS_END_POINT = `${MARKET_ANALYSIS_END_POINT}/customer-details`;
const CUSTOMER_PRODUCTS_END_POINT = `${MARKET_ANALYSIS_END_POINT}/commodities`;
const CUSTOMER_CONTRACTS_END_POINT = `${MARKET_ANALYSIS_END_POINT}/contracts`;
const CUSTOMER_STYLES_END_POINT = `${MARKET_ANALYSIS_END_POINT}/styles`;
const CUSTOMER_PERIOD_TYPES_END_POINT = `${MARKET_ANALYSIS_END_POINT}/period-types`;
const CUSTOMER_TENORS_END_POINT = `${MARKET_ANALYSIS_END_POINT}/tenors`;

export const fetchCustomerTenors = async (params) => {
  return await api.get(CUSTOMER_TENORS_END_POINT, { ...params });
};

export const fetchCustomerPeriodTypes = async (params) => {
  return await api.get(CUSTOMER_PERIOD_TYPES_END_POINT, { ...params });
};

export const fetchCustomerContracts = async (params) => {
  return await api.get(CUSTOMER_CONTRACTS_END_POINT, { ...params });
};

export const fetchCustomerStyles = async (params) => {
  return await api.get(CUSTOMER_STYLES_END_POINT, { ...params });
};

export const fetchCustomerProducts = async () => {
  return await api.get(CUSTOMER_PRODUCTS_END_POINT);
};

export const exportMarketAnalysis = async (params) => {
  return await api.get(EXPORT_MARKET_ANALYSIS_END_POINT, { ...params });
};

export const exportMarketAnalysisFiles = async (params) => {
  return await api.get(EXPORT_FILES_END_POINT, { ...params });
};

export const fetchMarketAnalysisGraph = async (param) => {
  return await api.get(MARKET_ANALYSIS_GRAPH_END_POINT, { ...param });
};

export const fetchMarketAnalysisTableData = async (queryParams) => {
  return await api.get(MARKET_ANALYSIS_END_POINT, { ...queryParams });
};
export const fetchTimeSeriesTable = async (queryParams) => {
  handleTimeSeriesTableFilters(queryParams);
  return await api.get(`${TIME_SERIES_END_POINT}`, { ...queryParams });
};

export const fetchCustomerDetailsTable = async (queryParams) => {
  handleTimeSeriesTableFilters(queryParams);
  return await api.get(`${CUSTOMER_DETAILS_END_POINT}`, { ...queryParams });
};


export const fetchTimeSeriesGraph = async (queryParams) => {
  const param =  validateAndGenerateParams(queryParams);
  if (param===null) {
    return ;
  }
  return await api.get(`${TIME_SERIES_GRAPH_END_POINT}?${param}`);
};

export const fetchMarketAnalysisFilters = async () => {
  return await api.get(FILTERS_GRAPH_END_POINT);
};

export const fetchMarketAnalysisTableFilters = async () => {
  return await api.get(TABLE_FILTER_END_POINT);
};


export { FILTERS_GRAPH_END_POINT };

export const fetchTimeSeriesDeltas = async () => {
  return await api.get(TIME_SERIES_DELTA_END_POINT);
};
export const fetchTimeSeriesTenors = async (queryParams) => {
  return await api.get(TIME_SERIES_TENORS_END_POINT, { ...queryParams });
};
export const fetchTimeSeriesPeriodTypes = async (queryParams) => {
  return await api.get(TIME_SERIES_PERIOD_TYPES_END_POINT, { ...queryParams });
};

export const fetchDailyReport = async (queryParams) => {
  return await api.get(DAILY_REPORT_END_POINT, { ...queryParams });
};

export const fetchStrikeVolComparison = async (queryParams) => {
  return await api.get(
    `${MARKET_ANALYSIS_END_POINT}/daily-report/strike-vol-comparison`,
    { ...queryParams }
  );
};

export const fetchIronMatrix = async (queryParams) => {
  return await api.get(IRON_MATRIX_END_POINT, { ...queryParams });
};

export const fetchIronMatrixTenors = async (queryParams) => {
  return await api.get(IRON_MATRIX_TENORS_END_POINT, { ...queryParams });
};

export const fetchIronMatrixOptionTypes = async () => {
  return await api.get(IRON_MATRIX_OPTION_TYPES_END_POINT);
};

export const pullIronMatrixToPricer = async (body) => {
  return await api.post(IRON_MATRIX_PULL_TO_PRICER_END_POINT, {}, { ...body });
};

export { TABLE_FILTER_END_POINT, DAILY_REPORT_END_POINT };